import React, { useState, useEffect } from "react";
import "./styles/Navbar.css";
import logo from "./styles/logo.png";
import { FaBars, FaTimes } from "react-icons/fa";
import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";
import { Link } from "react-router-dom";
import useBodyScrollLock from "./hooks/useBodyScrollLock";
import { useVerifiedDirector } from "./utils/VerifiedDirectorContext";
import usePolling from "./hooks/useMessagePolling";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useBodyScrollLock(menuOpen);

  const email = localStorage.getItem("email") || "";

  const userData = JSON.parse(localStorage.getItem("loggedInUser")) || {};
const userId = userData?.userId || userData?.data?.userId;

const { verifiedDirector } = useVerifiedDirector();

  const navItems = [
    { to: "/dashboard", label: "My Projects" },
    { to: "/post-casting-call", label: "Post a Job" },
    {
      to: "/search",
      label: "Search Talent",
      disabled: !verifiedDirector,
    },
    { to: "/favourites", label: "Favorites" },
    {
      to: "/inbox",
      label: "Mail",
      badge: unreadCount > 0 ? ` (${unreadCount})` : null,
    },
  ];




  /* -------------------- FETCH UNREAD MAIL COUNT -------------------- */

  const fetchUnreadCount = async () => {
    if (!email) return;

    try {
      const resp = await api.get(
        ENDPOINTS.getUnreadMessageCount(),
        { params: { email } }
      );

      setUnreadCount(resp.data?.data?.unreadMessageCount || 0);
    } catch (err) {
      console.error("Unread count fetch failed:", err);
    }
  };

  usePolling(fetchUnreadCount, {
  enabled: !!email,
  interval: 30000,
  immediate: true,
});
  


  /* -------------------- LOGOUT -------------------- */

  const handleLogout = () => {
    const rememberedUsername = localStorage.getItem("rememberedUsername");

    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    if (rememberedUsername) {
      localStorage.setItem("rememberedUsername", rememberedUsername);
    }

    localStorage.setItem("logout", Date.now());

    window.location.replace("/login");
  };

  /* -------------------- SEARCH ACCESS CONTROL -------------------- */

  const handleSearchClick = (e) => {
    if (!verifiedDirector) {
      e.preventDefault();
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* LEFT */}
        <div className="navbar-left">
          <img src={logo} alt="DirectSubmit Logo" className="logo-img" />

          <div className="nav-links">
            {navItems.slice(0, 4).map((item) => (
              <Link
                key={item.to}
                to={item.disabled ? "#" : item.to}
                className={`nav-link ${item.disabled ? "disabled-link" : ""}`}
                onClick={
                  item.label === "Search Talent"
                    ? handleSearchClick
                    : undefined
                }
                style={
                  item.disabled
                    ? { opacity: 0.5, cursor: "not-allowed" }
                    : {}
                }
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="navbar-right nav-links">
          <Link to="/inbox" className="mail-nav-btn">
            Mail
            {unreadCount > 0 && <span>&nbsp;({unreadCount})</span>}
          </Link>

          <button className="sign-out-btn" onClick={handleLogout}>
            Sign Out
          </button>
        </div>

        {/* MOBILE ICON */}
        <div
          className="hamburger-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="navbar-bottom">
        <div className="navbar-left"></div>

        <div className="navBarCenter"></div>

        <div className="navbar-right">
          <Link to="/account" className="bottom-link">
            Edit Account
          </Link>

          <Link to="/contact" className="bottom-link">
            Contact
          </Link>
        </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <button
            className="mobile-menu-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>

          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.disabled ? "#" : item.to}
              className={`mobile-link ${item.disabled ? "disabled-link" : ""}`}
              onClick={(e) => {
                if (item.label === "Search Talent") {
                  handleSearchClick(e);
                }
                setMenuOpen(false);
              }}
              style={
                item.disabled
                  ? { opacity: 0.5, cursor: "not-allowed" }
                  : {}
              }
            >
              {item.label}
              {item.badge && (
                <span className="badge">{item.badge}</span>
              )}
            </Link>
          ))}

          <Link
            to="/account"
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            Edit Account
          </Link>

          <Link
            to="/contact"
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>

          <button className="mobile-signout" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navbar;